import {formatDistanceToNowStrict, isValid} from 'date-fns';
import {convertStringLocaleToDateFns} from 'platform/locale';
import {match, Pattern} from 'ts-pattern';

import {isNil} from 'ramda';

import i18n from '@dms/i18n';

import {parseDate, type Nullish} from 'shared/web';

export const formatEngagementLastViewed = (lastOpenedAt: string | Nullish): string | null =>
  match(parseDate(lastOpenedAt))
    .with(Pattern.when(isNil), () => null)
    .with(
      Pattern.when((date) => !isValid(date)),
      () => null
    )
    .otherwise((date) =>
      formatDistanceToNowStrict(date, {
        addSuffix: true,
        locale: convertStringLocaleToDateFns(i18n.language),
      })
    );
